import { render, staticRenderFns } from "./AssignListItem.vue?vue&type=template&id=887be904&scoped=true&"
import script from "./AssignListItem.vue?vue&type=script&lang=js&"
export * from "./AssignListItem.vue?vue&type=script&lang=js&"
import style0 from "./AssignListItem.vue?vue&type=style&index=0&id=887be904&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887be904",
  null
  
)

export default component.exports